import React from "react";
import PropTypes from "prop-types";
import "./TelephoneEmailLink.css";
import WhatsAppButton from "./WhatsAppButton";
import { Button } from "./ui";

const TelephoneEmailLink = ({ phoneNumber, emailAddress }) => {
  return (
    <div className="contact-links space-y-4">
      <div className="contact-phone-flex">
        {/* <WhatsAppButton phoneNumber={"+4915756850714"} pulsate={true} /> */}
        <Button
          as="a"
          href={`tel:${phoneNumber}`}
          variant="outline"
          size="medium"
          style={{
            backgroundColor: "transparent",
            color: "white",
            borderColor: "white",
          }}
          className="text-white"
        >
          {phoneNumber}
        </Button>
      </div>
      <div className="contact-phone-flex">
        <Button
          as="a"
          href={`mailto:${emailAddress}`}
          variant="outline"
          size="medium"
          style={{
            backgroundColor: "transparent",
            color: "white",
            borderColor: "white",
          }}
          className="text-white"
        >
          {emailAddress}
        </Button>
      </div>
    </div>
  );
};

TelephoneEmailLink.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
};

export default TelephoneEmailLink;
